// extracted by mini-css-extract-plugin
export default {"card":"card_card__oOaZE","header":"card_header__zDJD6","content":"card_content__ltAJe"};